module.exports = __webpack_public_path__ + "img/swiper-img4-thumb.651e41eb.png";